var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.0589 8.0589 0 18 0C27.9411 0 36 8.0589 36 18C36 27.9411 27.9411 36 18 36C8.0589 36 0 27.9411 0 18Z",
    fill: "#3B5998"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8769 28.5836V18.7907H22.5802L22.9385 15.416H19.8769L19.8816 13.7269C19.8816 12.8467 19.9652 12.3751 21.2294 12.3751H22.9194V9H20.2157C16.9681 9 15.8251 10.6371 15.8251 13.3902V15.4163H13.8008V18.791H15.8251V28.5836H19.8769Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.cfc6880600bde9b9d634aba13dc9ced7.svg";
export { ForwardRef as ReactComponent };